/**
 * wl-quickview-variant.js — Woollooms (2026-07-30)
 *
 * SORUN:
 *   Ürün kartında "From $67.50" yazarken, "Choose options" (hızlı görünüm)
 *   penceresi $375.00 açılıyordu.
 *
 * NEDEN:
 *   Hızlı görünüm, ürünü hiçbir varyant belirtmeden çağırıyor
 *   (`/products/xxx?view=modal`). Varyant belirtilmeyince Shopify
 *   `product.selected_or_first_available_variant` yani ÜRÜNÜN İLK VARYANTINI
 *   seçiyor. Bu mağazadaki halılarda varyant sırası en BÜYÜK ölçüyle başlıyor
 *   (örn. 8'2" x 9'10" = $375), en ucuz ölçü ise listenin sonunda.
 *
 *   Kart bağlantısı 2026-07-23'te en ucuz varyantla açılacak şekilde düzeltilmişti,
 *   ama temanın kendi kodu (theme.js -> QuickView.quickview) adresteki soru
 *   işaretinden sonrasını siliyor:
 *       this.getAttribute('data-product-url').split('?')[0]
 *   Bu yüzden `?variant=...` hızlı görünüme hiç ulaşamıyordu.
 *
 * ÇÖZÜM:
 *   theme.js'e DOKUNMADAN, tarayıcıya kayıtlı `quick-view` bileşeninin
 *   `quickview` metodunu üzerine yazıyoruz. Tek fark: kartın verdiği
 *   `data-wl-variant` değerini adrese `&variant=` olarak ekliyoruz.
 *   Böylece fiyat, ölçü/renk seçimi ve sepete eklenecek ürün ÜÇÜ DE tutarlı olur
 *   (sadece yazıyı değiştirmek yanıltıcı olurdu: ekranda 67.50 yazıp sepete 375
 *   girerdi).
 *
 *   `data-wl-variant` yoksa davranış birebir eskisi gibi kalır.
 */
(function () {
  function patch() {
    var QuickView = window.customElements && customElements.get('quick-view');
    if (!QuickView || QuickView.prototype.__wlVariantPatched) return false;

    QuickView.prototype.__wlVariantPatched = true;

    QuickView.prototype.quickview = function () {
      var drawerContent = this.querySelector(this.selector);
      var productUrl = (this.getAttribute('data-product-url') || '').split('?')[0];
      var variantId = this.getAttribute('data-wl-variant');
      var sectionUrl = productUrl + '?view=modal';

      if (variantId) {
        sectionUrl += '&variant=' + encodeURIComponent(variantId);
      }

      var self = this;
      fetch(sectionUrl)
        .then(function (response) { return response.text(); })
        .then(function (responseText) {
          setTimeout(function () {
            var parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            var productElement = parsedHTML.querySelector(self.selector);
            if (!productElement) return;

            self.setInnerHTML(drawerContent, productElement.innerHTML);
            theme.a11y.trapFocus(self, self.focusElement);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            document.dispatchEvent(new CustomEvent('quickview:loaded', {
              detail: { productUrl: self.getAttribute('data-product-url') }
            }));
          }, 200);
        })
        .catch(function (e) { console.error(e); });
    };

    return true;
  }

  // theme.js de defer ile yükleniyor ve bu dosyadan ÖNCE geliyor; yine de
  // bileşen henüz kayıtlı değilse tanımlanmasını bekleyip tekrar deniyoruz.
  if (!patch() && window.customElements && customElements.whenDefined) {
    customElements.whenDefined('quick-view').then(patch);
  }
})();
